import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RETURNS_VIEW_ID } from './view-id-constants';

export const Returns = {
  label: <FormattedMessage defaultMessage='Returns' description='ordersPage.nav.returns' id='yA9wKG' />,
  id: RETURNS_VIEW_ID,
};
